import {OperableAccount} from './OperableTarget';
import {OperationAlias} from './OperationAlias';
import {OperationModel} from './OperationModel';

export type AccountsOperationsAggregate = {
    [K in OperableAccount.Type]: Array<AccountsOperationsAggregate.AccountWithOperations>;
};

export namespace AccountsOperationsAggregate {
    type IntermediateIndex = {
        [K in OperableAccount.Type]: Record<OperableAccount.Id, AccountWithOperations>;
    };

    export type AccountWithOperations = OperableAccount & {
        operations: {
            [K in OperationAlias]?: OperationModel[];
        };
    };

    export const fromLists = (operations: OperationModel[], accounts: OperableAccount[]) => {
        const index: IntermediateIndex = {fiat: {}, crypto: {}, stablecoin: {}};

        for (const account of accounts) {
            index[account.type][account.id] = {...account, operations: {}};
        }

        for (const operation of operations) {
            const baseAccount = OperationModel.getMainAccount(operation);
            // TODO (noUncheckedIndexedAccess)
            const account = index[baseAccount.type][baseAccount.id];
            if (!account) {
                // I'm not sure what would be most correct behavior so I'll just do "The Next Best Thing™️"
                // and skip operations with accounts not present in accounts list, but also log an error
                console.error(`List of operations had an account ${baseAccount.id} not provided in list of accounts`);
                continue;
            }
            const alias = OperationAlias.from(operation);
            const accountOperations = account.operations[alias] ?? (account.operations[alias] = []);
            {
                accountOperations.push(operation);
            }
        }

        const result: AccountsOperationsAggregate = {
            fiat: Object.values(index.fiat),
            crypto: Object.values(index.crypto),
            stablecoin: Object.values(index.stablecoin),
        };

        return result;
    };
}
